import apolloClient from '../../utils/apollo-client';
import { saveClaim as mutation } from '../graphql/claims';

export default async function createUserApi(payLoad) {
  const response = await apolloClient().then((client) =>
    client.mutate({
      mutation,
      variables: {
        payLoad
      }
    })
  );

  return response.data.saveClaim;
}
